<template>
  <div v-if="visible" class="global-loading">
    <div class="loading-content">
      <i class="el-icon-loading loading-icon"></i>
      <p class="loading-text">{{ text }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "GlobalLoading",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "正在加载中...",
    },
    background: {
      type: String,
      default: "rgba(0, 0, 0, 0.6)",
    },
  },
};
</script>

<style scoped>
.global-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.7);
}

.loading-content {
  text-align: center;
  color: var(--primary-color);
}

.loading-icon {
  font-size: 80px;
  animation: spin 2s linear infinite;
  margin-bottom: 10px;
}

.loading-text {
  font-size: 3rem;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GlobalLoading.vue